// -- todo - base service class
import { RealtimeClient } from "./RealtimeClient";
import { RestClient } from "./restClient";
import { AuthService } from "./authService";

export class TranslationService {
	constructor(options) {
		this._options = options;
		this._rc = new RealtimeClient();
		this._restClient = new RestClient();
		this._authService = new AuthService();
	}

	loadTranslations(appId, callback) {
		const url = `/translation-app/api/applications/${appId}/translations`;
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}

	loadTranslationsForLocale(appId, locale, callback) {
		const url = `/translation-app/api/translations/${appId}/${locale}`;
		if (callback) {
			this._restClient.exec_get(url, callback);
		} else {
			return new Promise((resolve, reject) => {
				this._restClient.exec_get(url, (err, result) => {
					if (err) {
						reject(err);
						return;
					}
					resolve(result);
				});
			});
		}
	}
}
